import {useCLDispatch, useCLReduxSelector} from 'common/src/redux/hooks';
import initializeApp from 'common/src/redux/thunks/initializeApp';
import React, {PropsWithChildren, useEffect} from 'react';
import CLFullContainerOverlay from '../CLFullContainerOverlay/CLFullContainerOverlay';
import styles from './BootstrapLoader.module.scss';

function BootstrapLoader({children}: PropsWithChildren) {
  const dispatch = useCLDispatch();

  useEffect(
    function init() {
      dispatch(initializeApp());
    },
    [dispatch],
  );

  const isAppInitialized = useCLReduxSelector((state) => state.application.isAppInitialized);

  if (!isAppInitialized) {
    return <CLFullContainerOverlay className={styles.container} />;
  }

  return <>{children}</>;
}

export default BootstrapLoader;
